export const TreasuryLink = ({ cusip }: { cusip: string }) => {
  if (!cusip) {
    return '-'
  }

  return (
    <a href={`https://www.treasurydirect.gov/auctions/auction-query/?cusip=${cusip}`} target="_blank" rel="noopener noreferrer" className="hover:underline">
      {cusip}
    </a>
  )
}